import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { useTheme } from '@mui/material';
import { useWorkSchedule } from '../context/useTimeClock';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export function ModalDelete() {
  const theme = useTheme();
  const { 
    isDeleteModalOpen, 
    closeDeleteModal, 
    handleDeleteWorkSchedule, 
    isDeleting 
  } = useWorkSchedule();

  return (
    <Modal
      open={isDeleteModalOpen}
      onClose={closeDeleteModal}
      aria-labelledby="modal-delete-title"
      aria-describedby="modal-delete-description"
    >
      <Box sx={style}>
        <Typography id="modal-delete-title" variant="h6" component="h2" color={theme.palette.text.primary}>
          Confirmar Exclusão
        </Typography>
        <Typography id="modal-delete-description" sx={{ mt: 2, mb: 3 }} color={theme.palette.text.secondary}>
          Tem certeza que deseja excluir esta jornada de trabalho? Esta ação não pode ser desfeita.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button 
            onClick={closeDeleteModal} 
            variant="outlined"
            disabled={isDeleting}
          >
            Cancelar
          </Button>
          <Button 
            onClick={handleDeleteWorkSchedule} 
            variant="contained" 
            color="error"
            disabled={isDeleting}
          >
            {isDeleting ? 'Excluindo...' : 'Excluir'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
} 